function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import coreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import customerLocaleKeys from '../../../../../locales/keys';
import { retrieveEntitlementUsage, retrieveSharedEntitlements, setCurrentPage, setEntitlementShareStatus, setEntitlementsPaginationData, setEntitlementsSearchTerm, setSelectedSharedEntitlementIndex, setSharedEntitlementsPageSize, updateEntitlementShareStatus } from '../../../../../reducers/actions/shared.entitlements.actions';
import { CurrentCustomerIdSelector, RouteParams } from '../../../../../reducers/selectors/customer.selectors';
import { currentPageNumberSelector, entitlementRecordCountSelector, entitlementsPaginationDataSelector, entitlementUsagesTableDataSelector, formattedEntitlementsSelector, isFetchingEntitlementsSelector, isUpdatingEntitlementShareStatusSelector, isFetchingEntitlementUsageSelector, selectedEntitlementIndexSelector, selectedEntitlementSelector, sharedEntitlementsPageSizeSelector } from '../../../../../reducers/selectors/shared.entitlements.selectors';
import { DEFAULT_PAGE_NUMBER, DEFAULT_MAXIMUM_SLOTS } from './shared.entitlements.list.constants';
import { ENTITLEMENT_CONTEXT_TYPES, ENTITLEMENT_SHARE_STATUS, UNIT_OF_MEASURES } from '../../../../../customercare.constants';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from '../../../servicesAndUsage/usageDetails/usage.details.config';
import { NA } from '../../../../../reducers/constants/billing.payments.constants';
import { TRANSACTION_DETAILS_STATE } from '../../../transactions/transactions.config';
import { ConvergentBillerCurrencyCodeSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { SERVICES_AND_SHARED_ENTITLEMENTS } from '../../../servicesAndUsage/services.and.usage.config';
var SharedEntitlementsController = /*#__PURE__*/function () {
  function SharedEntitlementsController($ngRedux, $state, uiNotificationService) {
    _classCallCheck(this, SharedEntitlementsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      coreLocaleKeys: coreLocaleKeys,
      customerLocaleKeys: customerLocaleKeys,
      ENTITLEMENT_CONTEXT_TYPES: ENTITLEMENT_CONTEXT_TYPES,
      handleSubscriberIdClick: this.handleSubscriberIdClick.bind(this),
      maximumSlots: DEFAULT_MAXIMUM_SLOTS,
      NA: NA,
      onEntitlementsPageSelected: this.onEntitlementsPageSelected.bind(this),
      onEntitlementsPageSizeOptionSelected: this.onEntitlementsPageSizeOptionSelected.bind(this),
      onSearchSubmitted: this.onSearchSubmitted.bind(this),
      SERVICE_USAGE_DETAILS_STATE_NAME: SERVICE_USAGE_DETAILS_STATE_NAME,
      TRANSACTION_DETAILS_STATE: TRANSACTION_DETAILS_STATE,
      uiNotificationService: uiNotificationService,
      UNIT_OF_MEASURES: UNIT_OF_MEASURES
    });
  }
  return _createClass(SharedEntitlementsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.UnitsOfMeasure, CODES.UsageUnitConversion];
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        retrieveEntitlementUsage: retrieveEntitlementUsage,
        retrieveSharedEntitlements: retrieveSharedEntitlements,
        setCurrentPage: setCurrentPage,
        setEntitlementShareStatus: setEntitlementShareStatus,
        setEntitlementsPaginationData: setEntitlementsPaginationData,
        setEntitlementsSearchTerm: setEntitlementsSearchTerm,
        setSelectedSharedEntitlementIndex: setSelectedSharedEntitlementIndex,
        setSharedEntitlementsPageSize: setSharedEntitlementsPageSize,
        stateGo: stateGo,
        updateEntitlementShareStatus: updateEntitlementShareStatus
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          currencyCode: ConvergentBillerCurrencyCodeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPageNumber: currentPageNumberSelector(store),
          entitlementUsageTableData: entitlementUsagesTableDataSelector(store),
          entitlements: formattedEntitlementsSelector(store),
          entitlementsPaginationData: entitlementsPaginationDataSelector(store),
          isFetchingEntitlementUsage: isFetchingEntitlementUsageSelector(store),
          isFetchingEntitlements: isFetchingEntitlementsSelector(store),
          isUpdatingEntitlementShareStatus: isUpdatingEntitlementShareStatusSelector(store),
          pageSize: sharedEntitlementsPageSizeSelector(store),
          recordCount: entitlementRecordCountSelector(store),
          routeParams: RouteParams(store),
          selectedEntitlement: selectedEntitlementSelector(store),
          selectedEntitlementIndex: selectedEntitlementIndexSelector(store)
        };
      };
      this.entitlementTooltip = require('../../../../../components/shared/tooltipTemplates/entitlement.tooltip.html');
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.state.routeParams.entitlementIndex) {
        this.actions.setSelectedSharedEntitlementIndex(this.state.routeParams.entitlementIndex || 0);
      }
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.entitlementColumn = {
        field: 'entitlementName',
        displayName: i18n.translate(customerLocaleKeys.ENTITLEMENT),
        visible: false
      };
      this.subscriberIdColumn = {
        field: 'subscriberId',
        displayName: i18n.translate(customerLocaleKeys.SERVICES_AND_USAGE.SHARED_ENTITLEMENTS.SUBSCRIBER_ID),
        cellTemplate: require('./cellTemplates/subscriberId.html'),
        visible: false
      };
      this.servicesGrid = {
        appScopeProvider: this,
        enableSorting: false,
        data: this.state.entitlementUsageTableData,
        onRegisterApi: function onRegisterApi(gridApi) {
          _this.serviceGridApi = gridApi;
        },
        columnDefs: [{
          field: 'serviceId',
          displayName: i18n.translate(customerLocaleKeys.IDENTIFIER_ABBREVIATION),
          cellTemplate: require('./cellTemplates/serviceId.html')
        }, {
          field: 'friendlyName',
          displayName: i18n.translate(customerLocaleKeys.SERVICES_AND_USAGE.SHARED_ENTITLEMENTS.FRIENDLY_NAME)
        }, this.subscriberIdColumn, this.entitlementColumn, {
          field: 'ownerLabel',
          displayName: '',
          cellTemplate: require('./cellTemplates/owner.html')
        }, {
          field: 'usage',
          displayName: i18n.translate(customerLocaleKeys.SERVICES_AND_USAGE.SHARED_ENTITLEMENTS.USAGE),
          cellTemplate: require('./cellTemplates/usage.html')
        }]
      };
      this.onEntitlementsPageSelected(DEFAULT_PAGE_NUMBER);
    }
  }, {
    key: "fetchSharedEntitlements",
    value: function fetchSharedEntitlements() {
      var _this2 = this;
      this.actions.retrieveSharedEntitlements(this.state.currentCustomerId, this.state.entitlementsPaginationData.searchTerm, this.state.entitlementsPaginationData.pageNumber, this.state.entitlementsPaginationData.pageSize).then(function () {
        if (_this2.state.entitlements.length) {
          _this2.retrieveEntitlementUsage();
        }
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onSearchSubmitted",
    value: function onSearchSubmitted(searchTerm) {
      this.actions.setEntitlementsSearchTerm(searchTerm);
      this.actions.setEntitlementsPaginationData(DEFAULT_PAGE_NUMBER, this.state.entitlementsPaginationData.pageSize);
      this.fetchSharedEntitlements();
    }
  }, {
    key: "onEntitlementsPageSelected",
    value: function onEntitlementsPageSelected(pageNumber) {
      this.actions.setEntitlementsPaginationData(pageNumber, this.state.entitlementsPaginationData.pageSize);
      this.fetchSharedEntitlements();
    }
  }, {
    key: "onEntitlementsPageSizeOptionSelected",
    value: function onEntitlementsPageSizeOptionSelected(pageSize) {
      this.actions.setEntitlementsPaginationData(DEFAULT_PAGE_NUMBER, pageSize);
      this.fetchSharedEntitlements();
    }
  }, {
    key: "selectEntitlement",
    value: function selectEntitlement(entitlementIndex) {
      if (entitlementIndex === this.state.selectedEntitlementIndex) {
        return;
      }
      this.actions.setSelectedSharedEntitlementIndex(entitlementIndex);
      this.actions.setCurrentPage(DEFAULT_PAGE_NUMBER);
      this.retrieveEntitlementUsage();
    }
  }, {
    key: "retrieveEntitlementUsage",
    value: function retrieveEntitlementUsage() {
      var _this3 = this;
      this.entitlementColumn.visible = !!(this.state.selectedEntitlement && this.state.selectedEntitlement.EntitlementIdentifier && this.state.selectedEntitlement.EntitlementIdentifier.GroupCode);
      this.servicesGrid.data = [];
      return this.actions.retrieveEntitlementUsage(this.state.currentCustomerId, this.state.selectedEntitlement.EntitlementIdentifier, this.state.currentPageNumber, this.state.pageSize).then(function () {
        _this3.subscriberIdColumn.visible = _this3.state.selectedEntitlement.EntitlementContextTypeCode === ENTITLEMENT_CONTEXT_TYPES.HIERARCHY && _this3.state.entitlementUsageTableData.data && _this3.state.entitlementUsageTableData.data.some(function (service) {
          return service.subscriberId;
        });
        _this3.servicesGrid.data = _this3.state.entitlementUsageTableData;
      }).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "updateEntitlementShareStatus",
    value: function updateEntitlementShareStatus(entitlement) {
      var _this4 = this;
      var newStatus = entitlement.SharingStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? ENTITLEMENT_SHARE_STATUS.DISABLED : ENTITLEMENT_SHARE_STATUS.ENABLED;
      this.actions.updateEntitlementShareStatus(this.state.currentCustomerId, entitlement.EntitlementIdentifier, newStatus).then(function () {
        _this4.actions.setEntitlementShareStatus(_this4.state.entitlements.indexOf(entitlement), newStatus);
        _this4.uiNotificationService.transientSuccess(i18n.translate(newStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? _this4.customerLocaleKeys.SHARING_ACTIONS.ENABLE_SUCCESS : _this4.customerLocaleKeys.SHARING_ACTIONS.DISABLE_SUCCESS));
      }).catch(function (error) {
        _this4.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleSubscriberIdClick",
    value: function handleSubscriberIdClick(subscriberId) {
      this.$state.go(SERVICES_AND_SHARED_ENTITLEMENTS, {
        customerId: subscriberId
      });
    }
  }, {
    key: "pageSizeOptionSelected",
    value: function pageSizeOptionSelected(pageSize) {
      this.actions.setSharedEntitlementsPageSize(pageSize);
      this.onPageSelected(DEFAULT_PAGE_NUMBER);
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(pageNumber) {
      this.actions.setCurrentPage(pageNumber);
      this.retrieveEntitlementUsage();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: SharedEntitlementsController,
  template: require('./shared.entitlements.template.html')
};